import { render } from "./RightPane.vue?vue&type=template&id=88edb384&scoped=true"
import script from "./RightPane.vue?vue&type=script&lang=js"
export * from "./RightPane.vue?vue&type=script&lang=js"

import "./RightPane.vue?vue&type=style&index=0&id=88edb384&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88edb384"]])

export default __exports__